import React from 'react';
import { Box, Button, IconButton, Stack } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';

type FilterButtonProps = {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onReset?: () => void;
  isActive: boolean;
  summaryLabel: string;
  secondaryLabel?: string;
  isSmallScreen?: boolean;
  /** A square icon button; the reset lives in the filter menu that a tap opens. */
  iconOnly?: boolean;
};

export const FilterButton = ({
  onClick,
  onReset,
  isActive,
  summaryLabel,
  secondaryLabel,
  isSmallScreen,
  iconOnly,
}: FilterButtonProps) => {
  const hasSecondary = Boolean(secondaryLabel);
  if (iconOnly) {
    return (
      <Button
        variant={isActive ? 'soft' : 'outlined'}
        color={isActive ? 'primary' : 'inherit'}
        onClick={onClick}
        aria-label={summaryLabel}
        sx={{ minWidth: '44px', width: '44px', paddingInline: 0 }}>
        <FilterListIcon />
      </Button>
    );
  }
  return (
    <Box sx={{ display: 'flex', alignItems: 'stretch' }}>
      <Button
        variant="outlined"
        color={isActive ? 'primary' : 'inherit'}
        onClick={onClick}
        startIcon={<FilterListIcon />}
        sx={{
          minHeight: '44px',
          py: hasSecondary ? 0.5 : 0,
          alignItems: 'center',
          ...(isActive && onReset && { borderStartEndRadius: 0, borderEndEndRadius: 0, borderInlineEnd: 'none' }),
        }}>
        <Stack sx={{ alignItems: 'flex-start', textAlign: 'start', lineHeight: 1.2 }}>
          <Typography variant="body2" sx={{ whiteSpace: 'nowrap' }}>
            {summaryLabel}
          </Typography>
          {hasSecondary && (
            <Typography
              variant="caption"
              sx={{
                whiteSpace: isSmallScreen ? 'normal' : 'nowrap',
                lineHeight: 1.2,
                opacity: 0.85,
              }}>
              {secondaryLabel}
            </Typography>
          )}
        </Stack>
      </Button>
      {isActive && onReset && (
        <IconButton
          size="small"
          onClick={onReset}
          sx={{
            alignSelf: 'stretch',
            width: '32px',
            border: '1px solid',
            borderColor: 'primary.main',
            borderRadius: 0,
            borderStartEndRadius: '6px',
            borderEndEndRadius: '6px',
            color: 'primary.main',
            '&:hover': { bgcolor: 'primary.light' },
          }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
    </Box>
  );
};
